export function getRedirectionUrl(path) {
  const currentUrl = new URL(window.location.href);

  // change hostname from iforms to oneforms for redirection
  if (currentUrl.hostname.startsWith('iforms')) {
    currentUrl.hostname = currentUrl.hostname.replace(/^iforms/, 'oneforms');
  }
  const origin = `${currentUrl.protocol}//${currentUrl.hostname}`;
  const params = new URLSearchParams(document.location.search);
  const cuid = params.get('cuid');

  // handle special case for myoblogon path
  const normalizedPath = path?.includes('auth_reg/myoblogon')
    ? path.replace('auth_reg/myoblogon', 'auth_reg')
    : path;

  let pageType = 'unsecure';

  // cuids that should redirect to secure path
  const secureCuids = [
    'prioritypass_en_IN',
    'ita_it_IT',
    'enrollment_en_IN',
    'loci_en_NZ',
    'plat_en_IN',
    'payid_en_AU',
    'eufx_de_DE',
    'eufx_fi_FI',
    'eufx_fr_FR',
    'eufx_it_IT',
    'eufx_nb_NO',
    'eufx_nl_NL',
    'eufx_sv_SE',
    'nach_en_IN',
    'emi_en_IN',
  ];

  if (secureCuids.includes(cuid) || normalizedPath.includes('auth_reg')) {
    pageType = 'secure';
  }

  // forms that need to be redirected to a different cuid
  let redirectCuid = cuid;

  if (cuid === 'enrollment_en_IN') {
    const campaignId = params.get('campaignId');
    if (
      campaignId
      === 'Spend Linked Flipkart Vouchers on Platinum Reserve Credit Card'
      || campaignId
      === 'Spend%20Linked%20Flipkart%20Vouchers%20on%20Platinum%20Reserve%20Credit%20Card'
    ) {
      redirectCuid = 'enrollmentPlatres_en_IN';
    } else if (
      campaignId
      === 'Spend Linked 1000 MR Points on Membership Rewards Credit Card'
      || campaignId
      === 'Spend%20Linked%201000%20MR%20Points%20on%20Membership%20Rewards%20Credit%20Card'
    ) {
      redirectCuid = 'enrollmentMrcc_en_IN';
    }
  } else if (cuid === 'plat_en_IN') {
    redirectCuid = 'EpicurePlatcharge_en_IN';
  } else if (cuid === 'dddj_en_AU') {
    redirectCuid = 'dd_en_AU';
  } else if (cuid === 'dd_it_IT') {
    redirectCuid = 'dds_it_IT';
  } else if (cuid === 'ddmandate_it_IT') {
    redirectCuid = 'ddsepa_it_IT';
  }

  // remove unwanted query params to append
  const excludedParams = ['cuid', 'evtsrc', 'evttype'];
  const filteredParams = new URLSearchParams();

  params.forEach((value, key) => {
    if (!excludedParams.includes(key)) {
      filteredParams.append(key, value);
    }
  });

  const paramString = filteredParams.toString();

  // final redirection url: path="/iForms/:pageType/:cuid"
  let redirectionUrl = `/iForms/${pageType}/${redirectCuid}`;
  if (paramString) {
    redirectionUrl += `?${paramString}`;
  }

  // return the full url for redirection
  return `${origin}${redirectionUrl}`;
}
